import type { VoidFunctionComponent } from 'react';

import { useCanViewTrustRelationships } from '../../shared/permissions';
import type { OIDCProviderWithTeamName } from '../../../../../shared/model-typings/oidcprovider';

import TrustRelationshipsTable from './TrustRelationshipsTable';

import styles from './DetailsDrawer.module.less';

type OIDCProviderDetailsDrawerProps = {
  provider: OIDCProviderWithTeamName;
  currentTeamId?: number;
};

const OIDCProviderDetailsDrawer: VoidFunctionComponent<OIDCProviderDetailsDrawerProps> = ({
  provider,
  currentTeamId,
}) => {
  const canViewTrustRelationships = useCanViewTrustRelationships();

  return (
    <div>
      <h2 className={styles.title}>OIDC Provider Details</h2>

      <div className={styles.section}>
        <div className={styles.field}>
          <span className={styles.label}>Issuer</span>
          <div className={styles.value}>{provider.issuer}</div>
        </div>
      </div>

      {canViewTrustRelationships && (
        <>
          <h3 className={styles.title}>Trust Relationships</h3>
          <TrustRelationshipsTable providerId={provider.id} showCreateButton currentTeamId={currentTeamId} />
        </>
      )}
    </div>
  );
};

export default OIDCProviderDetailsDrawer;
